/**
 * Custom element for the download page that handles tab switching for both desktop and mobile views.
 *
 * @extends HTMLElement
 */
class MainDownloadPage extends HTMLElement {
  constructor() {
    super();

    /** @type {NodeListOf<HTMLButtonElement>} */
    this.tabs = this.querySelectorAll('.tab-button');

    /** @type {NodeListOf<HTMLElement>} */
    this.contents = this.querySelectorAll('.downloads');

    /** @type {NodeListOf<HTMLElement>} */
    this.mobileToggles = this.querySelectorAll('.mobile-toggle');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.dataset.target;
        if (targetId) {
          this.changePage(targetId);
        }
      });
    });

    this.mobileToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const parent = toggle.closest('.downloads');
        if (parent && parent.id) {
          const isMobile = window.innerWidth < 750;
          this.changePage(parent.id, isMobile);
        }
      });
    });

    this.init();
  }

  /**
   * Initializes the state based on screen size
   */
  init() {
    if (window.innerWidth < 750) {
      this.contents.forEach((content) => content.classList.remove('active'));
      this.tabs.forEach((tab) => tab.classList.remove('active'));
    }
  }

  /**
   * changes the active tab baised on an id
   *
   * @param {string} targetId
   * @param {boolean} toggle - whether to toggle if already active
   */
  changePage(targetId, toggle = false) {
    this.contents.forEach((content) => {
      if (toggle && content.id === targetId) {
        content.classList.toggle('active');
      } else {
        content.classList.toggle('active', content.id === targetId);
      }
    });

    this.tabs.forEach((tab) => {
      if (toggle && tab.dataset.target === targetId) {
        tab.classList.toggle('active');
      } else {
        tab.classList.toggle('active', tab.dataset.target === targetId);
      }
    });
  }
}

if (!customElements.get('main-download-page')) {
  customElements.define('main-download-page', MainDownloadPage);
}
